__turbopack_context__.v({
  "actionIcon": "SaveButton-module-scss-module__6cn1dW__actionIcon",
  "root": "SaveButton-module-scss-module__6cn1dW__root",
});
